// this is an autogenerated file from App/Account/Content/Tasks/mutation-update-filters.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Tasks($location_id: uuid!, $data: jsonb!) {
  insert_user_location_preferences_one(
    object: { location_id: $location_id, tasks_filter_presets: $data }
    on_conflict: {
      update_columns: tasks_filter_presets
      constraint: user_location_preferences_pkey
    }
  ) {
    user_id
    location_id
    tasks_filter_presets
  }
}

`